// Color constants and palette definitions
export const COLORS = {
  // Light theme colors  
  light: {
    primary: '#1976D2',
    primaryDark: '#1565C0',
    background: {
      default: '#e8f4f8',
      paper: '#FCFCFC',
      drawer: '#FCFCFC', // Dodane dla spójności typów
      secondary: '#ffffff',
    },
    notification: {
      unread: '#edf6ff',
      read: '#ffffff',
      hover: '#e3f2fd'
    },
    status: {
      awaria: '#ffcccc',
      naprawione: '#c8e6c9'
    },
    text: {
      primary: '#1D1D1D',
      secondary: '#666666'
    },
    borders: {
      primary: '#E1E4E8',          // Główny border color dla light
      secondary: '#D0D7DE',        // Secondary border
      accent: '#1976D2'            // Accent border
    }
  },
  
  // Dark theme colors - clean sidebar version
  dark: {
    primary: '#00b3fe',
    primaryLight: '#8ABFEB',
    primaryHover: '#90CAF9',
    primaryButton: '#019ccf',
    background: {
      default: '#000000',        // Czysty czarny główny background
      paper: '#0c0c0c',          // Bardzo ciemny szary dla paper
      drawer: '#222222',         // Jaśniejszy szary dla drawer/sidebar
      secondary: '#161B22',      // Ciemny dla secondary elements
      input: '#21262D',          // Ciemniejszy dla input'ów
      disabled: '#1C2128'        // Disabled background
    },
    notification: {
      unread: '#1a2635',
      read: '#262626',
      hover: '#233240'
    },
    status: {
      awaria: '#5c2b2b',
      naprawione: '#2b5c2b'
    },
    text: {
      primary: '#F0F6FC',         // Jaśniejszy tekst dla kontrastu
      secondary: '#8B949E',       // Secondary text
      disabled: 'rgba(240, 246, 252, 0.5)',
      placeholder: '#6E7681'      // Placeholder text
    },
    borders: {
      primary: '#525252',         // Główny border color - requested gray
      secondary: '#525252',       // Secondary border - również szary
      accent: '#58A6FF'           // Accent border
    }
  }
} as const;

// Common shadows
export const SHADOWS = {
  light: {
    elevation1: '0px 2px 8px rgba(25, 118, 210, 0.05)',
    elevation3: '0px 3px 12px rgba(25, 118, 210, 0.08)'
  },
  dark: {
    elevation1: '0px 2px 8px rgba(0, 0, 0, 0.5)',
    elevation3: '0px 3px 12px rgba(0, 0, 0, 0.6)'
  }
} as const;

// Create palette configurations
export const createLightPalette = () => ({
  background: {
    default: COLORS.light.background.default,
    paper: COLORS.light.background.paper,
    secondary: COLORS.light.background.secondary,
    notification: COLORS.light.notification
  },
  action: {
    hover: 'rgba(25, 118, 210, 0.04)',
    selected: 'rgba(25, 118, 210, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  divider: COLORS.light.borders.primary,        // Używamy border color dla dividers
  status: COLORS.light.status,
  borders: COLORS.light.borders                  // Expose borders for custom usage
});

export const createDarkPalette = () => ({
  background: {
    default: COLORS.dark.background.default,
    paper: COLORS.dark.background.paper,
    secondary: COLORS.dark.background.secondary,
    notification: COLORS.dark.notification
  },
  text: {
    primary: COLORS.dark.text.primary,
    secondary: COLORS.dark.text.secondary
  },
  status: COLORS.dark.status,
  action: {
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.3)',
  },
  primary: {
    main: COLORS.dark.primary,
    contrastText: '#FFFFFF'
  },
  divider: COLORS.dark.borders.primary,        // Używamy border color dla dividers
  borders: COLORS.dark.borders                  // Expose borders for custom usage
}); 